import { commonConstantTexts } from 'constants/constantText';
import moment from 'moment';

export const formatNotificationDate = (time: string | Date): string => {
  const date = moment(time);
  const today = moment();
  const yesterday = moment().subtract(1, 'days');

  if (date.isSame(today, 'day')) {
    return date.format('hh:mm A');
  } else if (date.isSame(yesterday, 'day')) {
    return 'yesterday';
  } else {
    return date.format(commonConstantTexts.dateFormat);
  }
};
